const OPTION_LABEL_PROP = 'label';
const OPTION_VALUE_PROP = 'value';

const DEFAULT_TRANSFORM_LABEL_PROP = 'name';
const DEFAULT_TRANSFORM_VALUE_PROP = 'id';

export function transformOptionFormat(
  option,
  labelProp = DEFAULT_TRANSFORM_LABEL_PROP,
  valueProp = DEFAULT_TRANSFORM_VALUE_PROP
) {
  if (!option) return undefined;
  return {
    [OPTION_LABEL_PROP]: option[labelProp],
    [OPTION_VALUE_PROP]: option[valueProp],
  };
}



// WEBPACK FOOTER //
// ./app/sagas/transformSelectOption.js